import { IconService } from './IconService';
export const IconComponent = ({ iconName, className }) => {
	return IconService(iconName, className);
};
